"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningSymptomCreateDto = instanceOfTuberculosisScreeningSymptomCreateDto;
exports.TuberculosisScreeningSymptomCreateDtoFromJSON = TuberculosisScreeningSymptomCreateDtoFromJSON;
exports.TuberculosisScreeningSymptomCreateDtoFromJSONTyped = TuberculosisScreeningSymptomCreateDtoFromJSONTyped;
exports.TuberculosisScreeningSymptomCreateDtoToJSON = TuberculosisScreeningSymptomCreateDtoToJSON;
exports.TuberculosisScreeningSymptomCreateDtoToJSONTyped = TuberculosisScreeningSymptomCreateDtoToJSONTyped;
/**
 * Check if a given object implements the TuberculosisScreeningSymptomCreateDto interface.
 */
function instanceOfTuberculosisScreeningSymptomCreateDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('answer' in value) || value['answer'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningSymptomCreateDtoFromJSON(json) {
    return TuberculosisScreeningSymptomCreateDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningSymptomCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'answer': json['answer'],
    };
}
function TuberculosisScreeningSymptomCreateDtoToJSON(json) {
    return TuberculosisScreeningSymptomCreateDtoToJSONTyped(json, false);
}
function TuberculosisScreeningSymptomCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'answer': value['answer'],
    };
}
//# sourceMappingURL=TuberculosisScreeningSymptomCreateDto.js.map